'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, useState } from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import CloseIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_close.svg';
import styles from './styles.module.scss';
import type { TagsInputProps } from './types';
export function TagInput(t0) {
  const $ = _c(35);
  const {
    tags,
    inputValue,
    placeholder,
    disabled,
    onRemove,
    onInputChange,
    onKeyDown,
    onFocus
  } = t0;
  const inputEl = useRef(null);
  const [showPlaceholder, setShowPlaceholder] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => inputEl.current?.focus();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const focusInput = t1;
  let t2;
  if ($[1] !== onFocus) {
    t2 = () => {
      onFocus?.();
      setShowPlaceholder(false);
    };
    $[1] = onFocus;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleFocus = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setShowPlaceholder(true);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleBlur = t3;
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = e => {
      const target = e.target as HTMLElement;
      const tagName = target.tagName.toLowerCase();
      if (tagName !== "input" && tagName !== "button" && target.closest("button") === null) {
        e.preventDefault();
        focusInput();
      }
    };
    t5 = {
      maxHeight: 80
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== inputValue.length || $[7] !== placeholder || $[8] !== showPlaceholder || $[9] !== tags.length) {
    t6 = tags.length === 0 && showPlaceholder && inputValue.length === 0 && <span className={styles.placeholder}>{placeholder}</span>;
    $[6] = inputValue.length;
    $[7] = placeholder;
    $[8] = showPlaceholder;
    $[9] = tags.length;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== disabled || $[12] !== onRemove || $[13] !== tags) {
    let t8;
    if ($[15] !== disabled || $[16] !== onRemove) {
      t8 = tag => <Tag key={tag.id} {...tag} disabled={disabled} onRemove={onRemove} />;
      $[15] = disabled;
      $[16] = onRemove;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    t7 = tags.map(t8);
    $[11] = disabled;
    $[12] = onRemove;
    $[13] = tags;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = inputValue.length > 0 && styles.hasValue;
  let t9;
  if ($[18] !== t8) {
    t9 = cn(styles.hiddenInput, t8);
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onInputChange) {
    t10 = e_0 => onInputChange(e_0.target.value);
    $[20] = onInputChange;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== disabled || $[23] !== handleFocus || $[24] !== inputValue || $[25] !== onKeyDown || $[26] !== t10 || $[27] !== t9) {
    t11 = <input ref={inputEl} className={t9} value={inputValue} onChange={t10} onKeyDown={onKeyDown} onFocus={handleFocus} onBlur={handleBlur} disabled={disabled} type="text" />;
    $[22] = disabled;
    $[23] = handleFocus;
    $[24] = inputValue;
    $[25] = onKeyDown;
    $[26] = t10;
    $[27] = t9;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t7) {
    t12 = <div className={styles.tagsWrapper}>{t7}{t11}</div>;
    $[29] = t11;
    $[30] = t7;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t6) {
    t13 = <div className={styles.tagsContainer} onMouseDown={t4}><div style={t5} className={styles.textareaScrollbar}>{t6}{t12}</div></div>;
    $[32] = t12;
    $[33] = t6;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}
const Tag = t0 => {
  const $ = _c(12);
  const {
    id,
    label,
    disabled: t1,
    onRemove
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== id || $[1] !== onRemove) {
    t2 = () => {
      onRemove?.(id);
    };
    $[0] = id;
    $[1] = onRemove;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleRemove = t2;
  let t3;
  if ($[3] !== label) {
    t3 = <span className={styles.tagLabel}>{label}</span>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <CloseIcon width={12} height={12} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== handleRemove) {
    t5 = <button type="button" className={styles.tagRemove} onClick={handleRemove}>{t4}</button>;
    $[6] = handleRemove;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== disabled || $[9] !== t3 || $[10] !== t5) {
    t6 = <div className={styles.tag} data-disabled={disabled}>{t3}{t5}</div>;
    $[8] = disabled;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};